export const aboutData = {
    title: "Welcome to Harish's World!",
    description1: "My name's Harish Mullagura. I am from Anantapur city, Andhra Pradesh. I am a Software Developer at Commvault.",
    description2: "I am a passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact. Also I am a strong believer that imagination brings the change and shows a path to develop something amazing and interesting.",
    image: 2
}